class RestockNotification extends HTMLElement {
    connectedCallback() {
        // Get all required elements.
        this.opener = this.querySelector("modal-opener");
        this.dialog = document.querySelector(this.opener.getAttribute("data-modal"));
        this.form = this.dialog.querySelector("form");
        this.formFeedback = this.form.elements.feedback;

        // Add submit listeners, and overrides for Enter key.
        this.form.addEventListener("submit", this.onSubmit.bind(this));
        this.form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"]').forEach(function (input) {
            input.addEventListener("keydown", function (e) {
                if (e.code === "Enter") {
                    e.preventDefault();
                    this.form.querySelector('button[type="submit"]').click();
                }
            });
        });

        this.setupTurnstile();
    }

    disconnectedCallback() {
        if (this.form.turnstile) turnstile.remove(this.form.turnstile);
    }

    setupTurnstile() {
        const form = this.form;
		const container = this.form.querySelector('[data-turnstile]');

		if (!container) return console.warn('RemoteForm: Turnstile not enabled because container not found.');

        const renderParams = {
            theme: 'light',
            sitekey: cloudflare_turnstile_key,
            action: `RestockNotification-${form.id}`,
            appearance: 'interaction-only',
            callback: function(token) {
                form.token = token;
            },
            'before-interactive-callback': function () {
                container.removeAttribute('inert');
            }
        };

        let firstRun = true;
		turnstile.ready(function() {
			if (!firstRun) return;
            firstRun = false; 
            form.turnstile = turnstile.render(container, renderParams);
		});
    }

    setSubmitting(submitting) {
        this.submitting = submitting;
        if (submitting) this.form.querySelector('[type="submit"]').setAttribute("disabled", "disabled");
        else this.form.querySelector('[type="submit"]').removeAttribute("disabled");
    }

    async onSubmit(e) {
        e.preventDefault();
        if (this.submitting) return;
        this.setSubmitting(true);

        const formData = new FormData(this.form);

        // Clear all errors.
        this.form.querySelectorAll("[data-error]").forEach((error) => error.remove());
        this.formFeedback.removeAttribute("data-status");
        this.formFeedback.innerHTML = "";

        try {
            const apiResponse = await fetch(`${ncol_api_url}/api/restockSubscription/create`, {
                method: "POST",
                body: formData
            });

            const responseData = await apiResponse.json();

            if (responseData.status !== "success") throw responseData;

            this.form.querySelector("[data-restock-notification-form-fields]").remove();

            const successContainer = document.createElement("div");
            successContainer.classList.add("flash", "flash--success", "restock-notification-content__success");

            const successContent = document.createElement("div");
            successContent.classList.add("flash__content");

            const successTitle = document.createElement("h3");
            successTitle.classList.add('flash__title');
            successTitle.textContent = "You‘re all set!";

            const successMessage = document.createElement("p");
            successMessage.textContent = `We‘ll let you know when this item is back in stock!`;
            if (responseData.existing) successMessage.textContent = `You‘re already subscribed to this item. ${successMessage.textContent}`;

            successContent.appendChild(successTitle);
            successContent.appendChild(successMessage);
            successContainer.appendChild(successContent);
            this.form.appendChild(successContainer);

            // if (responseData.existing) {
            //     const removeSub = document.createElement("button");
            //     removeSub.classList.add("button", "button--secondary");
            //     removeSub.type = "button";
            //     removeSub.textContent = "Remove Subscription";
            //     removeSub.addEventListener("click", this.removeSubscription.bind(this));
            //     this.form.appendChild(removeSub);
            // }

            successContainer.scrollIntoView();

            // BUG - modal-dialog doesn't have a generatable close button yet.
            // const successClose = document.createElement("button");
            // successClose.textContent = "Close";
            // successClose.addEventListener("click", this.closeDialog.bind(this));
        } catch (error) {
            let firstError = false;
            let formError = "We couldn‘t process your notification request. Please try again later.";
            this.formFeedback.dataset.status = "error";

            if (!error.status) {
                this.formFeedback.innerHTML = formError;
                this.formFeedback.scrollIntoView();
                return;
            }

            // If specific fields have errors, show errors on those fields.
            if (error.fields && error.fields.length > 0) {
                error.fields.forEach(function (item) {
                    // Check if field is an actual input.
                    const input = this.form.querySelector(`[name="${item.field}"]`);
                    if (!input) return;

                    // Skip if field is hidden.
                    if (input.type === "hidden") return;

                    // Show generic error if radio option (likely store selection).
                    if (input.type === "radio") {
                        formError = item.error;
                        return;
                    }

                    // Create error message and add to DOM.
                    input.classList.add("error");
                    const container = input.parentElement;

                    const errorMessage = document.createElement("small");
                    errorMessage.classList.add("form__message", "form__message--error");
                    errorMessage.dataset.error = "true";
                    errorMessage.textContent = item.error;
                    container.after(errorMessage);

                    if (!firstError) firstError = input;
                }, this);
            }

            // If there is a generic error, show it. Scroll to first error or generic one.
            if (error.message || formError) {
                this.formFeedback.innerHTML = error.message || formError;
                this.formFeedback.scrollIntoView();
            } else if (firstError) firstError.scrollIntoView();

            if (error.console) console.error("[Restock Notification] Server Error: ", error.console);
            else if (!error.fields) console.error("[Reserve In Store] Error: ", error);

            if (error.action) {
                if (error.action === "reload") location.reload();
            }

            this.setSubmitting(false);
        }
    }
}

customElements.define("restock-notification", RestockNotification);
